import settings from '../../../config/settings'
import axios from '../api/axios'

export default class Api {
  static getGallery() {
    return axios.get(`${settings.apiBaseURL}/gallery`)
  }
}
